import React from 'react';

const UserPage = () => {
    return (
        <div>
            <h1>user</h1>
        </div>
    );
};

export default UserPage;
export {};
